import { render, staticRenderFns } from "./CoachList.vue?vue&type=template&id=56d98c3b&scoped=true&lang=pug"
import script from "./CoachList.vue?vue&type=script&lang=js"
export * from "./CoachList.vue?vue&type=script&lang=js"
import style0 from "./CoachList.vue?vue&type=style&index=0&id=56d98c3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d98c3b",
  null
  
)

export default component.exports